import React, { Component } from 'react';
import { Modal, Checkbox } from 'carbon-components-react';
import _ from 'lodash';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Breadcrumb, Card } from '../../../../components';
import unitsOfMensurements from '../../../../fixtures/unitsOfmeasurement';

import {
  insertDmService,
  getByDmService,
  updateDmService,
  deleteDmService,
  getDmService
} from '../../../../services/Api';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      openMdDelete: false,
      listGroups: [],
      listSizes: unitsOfMensurements,
      selectedItemSize: null,
      providerSelecteds: [],
      fornecedoresTag: [],
      relatedProducts: [],
      OrcamentoObrigatorio: false,
      openMdConfirmFree: false,
      confirmFree: false,
      precoReferenciaTag: {
        value: '',
        floatValue: 0
      }
    };
  }

  componentWillMount = async () => {
    await this.getItem();
    await this.getGroups();
  };

  getUnitMensured = idSize => {
    const { listSizes } = this.state;
    const selecionado = listSizes.filter(
      value => parseInt(value.id, 10) === idSize
    );
    return selecionado[0];
  };

  getItem = async () => {
    const { match } = this.props;
    const { listSizes } = this.state;
    const urlId = match.params && match.params.id;
    if (urlId) {
      const result = await getByDmService('/TagPreco', urlId);

      const {
        fornecedores,
        nome,
        unidadeMedida,
        precoReferencia,
        orcamentoObrigatorio: OrcamentoObrigatorio,
        produtos,
        grupos
      } = await result;

      const precoReferenciaTag = { floatValue: precoReferencia };
      console.log('produtos tag', produtos);

      let relatedProducts = [];
      if (produtos.length) {
        relatedProducts = produtos;
      }

      const selectedItemSize = await listSizes.filter(
        item => parseInt(item.id, 10) === unidadeMedida
      );

      fornecedores.forEach(async(item) => {
        await this.add({
          id: item.idFornecedor,
          label: item.nomeFantasia
        }, {
          floatValue: item.preco
        });
      });

      await this.setState(
        {
          selectedItemSize: selectedItemSize[0],
          precoReferenciaTag,
          OrcamentoObrigatorio,
          name: nome,
          relatedProducts,
          grupos: grupos || [],
        }
      );
    }
  };

  getGroups = async () => {
    const {grupos} = this.state;
    const _groups = await getDmService('/ProdutoCategoria/GetByTipo/?tipo=1');
    const groupsSelects = _groups.map(value => ({
      id: value.id,
      label: value.nome,
      selected: grupos && grupos.filter(p=>p === value.id).length > 0
    }));
    this.setState({
      listGroups: groupsSelects
    },
    async () => {
      this.loadFornecedoresTags();
    });
  };

  onCheckGroup = (e, id) => {
    const {listGroups} = this.state;
    listGroups.find(p=>p.id === id).selected = e;
    this.setState({listGroups}, () => {
      this.loadFornecedoresTags();
    })
  }

  loadFornecedoresTags = async () => {
    const { listGroups } = this.state;
    const grupos = listGroups.filter(p=>p.selected).map(p=>p.id);
    if (grupos && grupos.length > 0) {
      const list = await getByDmService(
        '/Fornecedor/GetByGrupos/',
        `?grupos=${grupos.join(',')}&nomeProduto=`
      );
      const fornecedoresTag = list.map(item => ({
        id: item.id,
        label: `${item.nomeFantasia}`
      }));

      this.setState({
        fornecedoresTag
      });
    } else {
      this.setState({fornecedoresTag: []})
    }
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeSize = event => {
    this.setState({
      selectedItemSize: { id: event.id, label: event.label }
    });
  };

  saveDetails = async e => {
    e.preventDefault();    
    const {
      name,
      precoReferenciaTag,
      providerSelecteds,
      selectedItemSize,
      OrcamentoObrigatorio,
      confirmFree,
      listGroups
    } = this.state;

    const { match, history } = this.props;
    const urlId = match.params && match.params.id;
    const urlEdit = `/TagPreco/`;

    const idsProviders = providerSelecteds.map(item => ({
      idFornecedor: item.selectedFornecedorTag.id,
      preco: item.precoFornecedor.floatValue
    }));

    const formData = {
      Nome: name,
      PrecoReferencia: precoReferenciaTag.floatValue || 0,
      Fornecedores: idsProviders,
      UnidadeMedida: parseInt(selectedItemSize.id, 10),
      OrcamentoObrigatorio,
      grupos: listGroups.filter(p=>p.selected).map(p=>p.id)
    };

    const confirmSave = (typeof precoReferenciaTag === "object"  && precoReferenciaTag.floatValue > 0) || OrcamentoObrigatorio ? true : confirmFree
    if(confirmSave){
      try {
        if (urlId) {
          await updateDmService(urlEdit, urlId, formData);
          history.goBack();
          toast.success('Edição realizada com sucesso.');
        } else {
          await insertDmService(urlEdit, formData);
          await this.setState({confirmFree: false})
          history.goBack();
          toast.success('Nome salvo com sucesso.');
        }
      } catch (error) {
        toast.warn(
          'Desculpe-nos. Ocorreu alguma falha ao tentar salvar os dados'
        );
      }
    }else{
      this.setState({
        confirmFree: false,
        openMdConfirmFree: true
      })
    }

  };

  closeConfirmTag = (bool, event) => {
    console.log("event", event);
    if(bool){

      this.setState({
        openMdConfirmFree: false,
        confirmFree: true
      }, () => {
        this.saveDetails(event)
      });      
    }else{
      this.setState({
        openMdConfirmFree: false,
        confirmFree: false
      });
    }
  }

  modalDelete = () => {
    this.setState(prevState => ({
      openMdDelete: !prevState.openMdDelete
    }));
  };

  delete = async () => {
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;

    try {
      await deleteDmService('/TagPreco', urlId);
      toast.success('Deletado conforme o solicitado.');
      history.goBack();
    } catch (error) {
      toast.error('Um erro inesperado ocorreu ao tentar deletar');
    }
  };

  onChangePriceTag = event => {
    this.setState({ precoReferenciaTag: event });
  };

  onChangePriceProviders = (event, item) => {
    if(item){
      item.precoFornecedor = event;
    } else {
      this.setState({ precoFornecedor: event });
    }
  };

  onChangeFornecedorTag = async obj => {
    this.setState({ selectedFornecedorTag: obj });
  };

  addFornecedorTag = async() => {
    const {
      selectedFornecedorTag,
      precoFornecedor
    } = this.state;
    await this.add( selectedFornecedorTag, precoFornecedor);
  };

  add = async(selectedFornecedorTag, precoFornecedor) => {
    const {providerSelecteds} = this.state;
    const listProviders = _.clone(providerSelecteds, true);
    const listProvidersTemp = listProviders.map(
      item => item.selectedFornecedorTag
    );
    
    if (listProvidersTemp.filter(p=> p.id === selectedFornecedorTag.id).length === 0) {
      listProviders.push({
        selectedFornecedorTag,
        precoFornecedor
      });
    } else
    toast.warn("Este fornecedor já foi selecionado anteriormente");
    
    await this.setState({
      providerSelecteds: listProviders
    });
  }

  removeProviderSelectedts = index => {
    const { providerSelecteds } = this.state;
    const listProviders = _.clone(providerSelecteds, true);
    listProviders.splice(index, 1);
    this.setState({
      providerSelecteds: listProviders
    });
  };

  onChangeNameTag = () => {   
    this.setState(prevState => ({
      OrcamentoObrigatorio: !prevState.OrcamentoObrigatorio 
    }));
  }

  render() {
    const {
      name,
      precoReferenciaTag,
      openMdDelete,
      listGroups,
      listSizes,
      selectedItemSize,
      providerSelecteds,
      fornecedoresTag,
      selectedFornecedorTag,
      relatedProducts,
      precoFornecedor,
      OrcamentoObrigatorio,
      openMdConfirmFree,
    } = this.state;

    const { history, match } = this.props;
    const urlId = match.params && match.params.id;
    const disabledBtnAddProviders =
      selectedFornecedorTag === undefined || precoFornecedor === undefined;

    return (
      <div>
        {urlId ? (
          <Breadcrumb
            title="Editar Tag"
            description="Gerencie tags de produtos agência."
            renderRight={(() => (
              <div className="flex v-sm-margin">
                <button
                  className="bx--btn btn-primary-outlined h-sm-margin"
                  type="button"
                  onClick={() => this.modalDelete()}
                >
                  Remover
                </button>
              </div>
            ))()}
            renderLeft={(() => (
              <div
                className="breadcrumb-left-actions pointer"
                onClick={() => history.goBack()}
              >
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        ) : (
          <Breadcrumb
            title="Criar Tag"
            description="Gerencie tamanho de produtos agência."
            renderLeft={(() => (
              <div
                className="breadcrumb-left-actions pointer"
                onClick={() => history.goBack()}
              >
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        )}

        <Card className="center-box">
          <form onSubmit={this.saveDetails}>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">Nome da tag</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="Digite aqui o nome do produto"
                  name="name"
                  value={name}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-md-6 bx--col-xs-12">
                <Checkbox
                  className="v-lg-margin"
                  labelText="Orçamento Obrigatório"
                  id="OrcamentoObrigatorio"
                  name="OrcamentoObrigatorio"
                  checked={OrcamentoObrigatorio}
                  onChange={this.onChangeNameTag}
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Preço de Referência</label>
                <NumberFormat
                  getInputRef={ref => {
                    this.precoReferenciaTag = ref;
                  }}
                  id="precoFornecedor"
                  className="bx--text-input bx--text__input"
                  decimalSeparator=","
                  prefix="R$ "
                  fixedDecimalScale
                  name="precoReferenciaTag"
                  thousandSeparator="."
                  placeholder="R$ 0,00"
                  value={
                    precoReferenciaTag && precoReferenciaTag.floatValue >= 0
                      ? precoReferenciaTag.floatValue
                      : ''
                  }
                  onValueChange={e => this.onChangePriceTag(e)}
                  allowNegative={false}
                  decimalScale={2}
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Unidade de medida</label>
                <Select
                  className="search-dm"
                  name="sizes"
                  options={listSizes}
                  required
                  value={selectedItemSize}
                  onChange={e => this.onChangeSize(e)}
                  placeholder="Selecione a unidade de medida"
                  isClearable={false}
                  isSearchable
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-md-12 bx--col-xs-12">
                <label className="bx--label">Grupos</label>
              </div>
              {listGroups && listGroups.map(item => (
                <div className="bx--col-md-6 bx--col-xs-12">
                  <Checkbox
                    className="v-lg-margin"
                    labelText={item.label}
                    id={`grupo${item.id}`}
                    name="grupos"
                    value={item.id}
                    checked={item.selected}
                    onChange={(e) => {this.onCheckGroup(e, item.id)}}
                  />
                </div>
              ))}
            </div>

            {fornecedoresTag.length > 0 && (
              <React.Fragment>
                <div className="bx--row mg-left-20 animated fadeIn search-tag">
                  <div className="bx--col-xs-9 bx--col-md-5 v-md-margin selected-tag">
                    <label className="bx--label">Fornecedor</label>
                    <Select
                      className="search-dm-tag"
                      name="fornecedorTag"
                      options={fornecedoresTag}
                      value={selectedFornecedorTag}
                      onChange={this.onChangeFornecedorTag}
                      placeholder="Fornecedor"
                      isClearable={false}
                      isSearchable
                    />
                  </div>
                  <div className="bx--col-xs-12 bx--col-md-3 v-md-margin">
                    <label className="bx--label">Preço do Fornecedor</label>
                    <NumberFormat
                      getInputRef={ref => {
                        this.precoFornecedor = ref;
                      }}
                      id="precoFornecedor"
                      className="bx--text-input bx--text__input"
                      decimalSeparator=","
                      prefix="R$ "
                      fixedDecimalScale
                      name="precoFornecedor"
                      thousandSeparator="."
                      placeholder="R$ 0,00"
                      value={
                        precoFornecedor
                          ? precoFornecedor.floatValue
                          : ''
                      }
                      onValueChange={e => this.onChangePriceProviders(e)}
                      allowNegative={false}
                      decimalScale={2}
                    />
                  </div>
                  <div className="bx--col-xs-3 bx--col-md-1">
                    <button
                      kind="ghost"
                      type="button"
                      className="button button--clear button--icon"
                      style={{ height: '15px', marginTop: '45px' }}
                      onClick={() => this.addFornecedorTag()}
                      disabled={disabledBtnAddProviders}
                    >
                      <i className="material-icons">add_circle</i>
                    </button>
                  </div>
                </div>
              </React.Fragment>
            )}
            {providerSelecteds.length > 0 && (
              <React.Fragment>
                {providerSelecteds.map((item, index) => (
                  <div
                    key={item.id}
                    className="bx--row mg-left-20 animated fadeIn"
                  >
                    <div className="bx--col-xs-9 bx--col-md-6 v-md-margin selected-tag">
                      <label className="bx--label">
                        Fornecedor
                        {`#${index + 1}`}
                      </label>
                      <Select
                        className="search-dm"
                        name="fornecedorTag"
                        options={fornecedoresTag}
                        value={providerSelecteds[index].selectedFornecedorTag}
                        placeholder="Fornecedor"
                        isClearable={false}
                        disabled
                      />
                    </div>
                    <div className="bx--col-xs-12 bx--col-md-3 v-md-margin">
                      <label className="bx--label">Preço do Fornecedor</label>
                      <NumberFormat
                        getInputRef={ref => {
                          this.precoFornecedor = ref;
                        }}
                        id="precoFornecedor"
                        className="bx--text-input bx--text__input"
                        decimalSeparator=","
                        prefix="R$ "
                        fixedDecimalScale
                        name="precoFornecedor"
                        thousandSeparator="."
                        placeholder="R$ 0,00"
                        value={
                          item.precoFornecedor
                            ? item.precoFornecedor.floatValue
                            : ''
                        }
                        onValueChange={e => this.onChangePriceProviders(e, item)}
                        allowNegative={false}
                        decimalScale={2}
                      />
                    </div>
                    <div className="bx--col-xs-3 bx--col-md-2">
                      <button
                        kind="ghost"
                        type="button"
                        className="button button--clear button--icon danger"
                        onClick={() => this.removeProviderSelectedts(index)}
                      >
                        <i className="material-icons">cancel</i>
                      </button>
                    </div>
                  </div>
                ))}
              </React.Fragment>
            )}
            {relatedProducts.length > 0 && (
              <div className="bx--row mg-left-20 ">
                <div className="bx--col-md-10 bx--col-xs-12">
                  <p>
                    <strong>Produtos Vinculados:</strong>
                  </p>
                  <div className="bx--data-table-v2-container">
                    <table className="bx--data-table-v2 bx--data-table-v2--zebra responsive-carbon-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Produto</th>
                          <th>Material</th>
                          <th>Detalhe</th>
                        </tr>
                      </thead>
                      <tbody>
                        {relatedProducts.map(item => (
                          <tr key={item.id}>
                            <td>{item.codigo}</td>
                            <td>{item.produto}</td>
                            <td>{item.material}</td>
                            <td>{item.detalhe}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
 
            <div className="bx--row mg-left-20 v-md-margin ">
              <div className="bx--col-xs-12 btn-tags-price">
                <button
                  tabIndex="0"
                  className="bx--btn btn-secondary-color"
                  type="submit"
                >
                  Salvar
                </button>
                <button
                  tabIndex="0"
                  className="h-sm-margin bx--btn btn-secondary-outlined"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
              </div>
            </div>
            {openMdConfirmFree && (
              <Modal
                open={openMdConfirmFree}
                onRequestSubmit={e => this.closeConfirmTag(true, e)}
                onRequestClose={e => this.closeConfirmTag(false, e)}
                modalHeading="Produto Gratuito"
                primaryButtonText="Sim"
                secondaryButtonText="Não"
              >
                <h3>
                  Não tem valor no preço de referência. Deseja salvar os produtos desta tag como gratuitos?
                </h3>
              </Modal>
            )}  
          </form>
        </Card>

        {openMdDelete && (
          <Modal
            className="some-class"
            open={openMdDelete}
            modalHeading="Remover Item"
            primaryButtonText="Tenho certeza"
            secondaryButtonText="Cancelar"
            iconDescription="Cancelar e fechar"
            onRequestClose={() => this.modalDelete()}
            onRequestSubmit={() => this.delete()}
          >
            <p className="bx--modal-content__text">
              Você tem certeza que deseja deletar este item?
            </p>
          </Modal>
        )}
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/ManageTags/Edit.js